import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import SET_USER from './types';
import { fetchUser } from '~/services/user';
export default {
  fetchUser(_ref) {
    var _this = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;

      try {
        const {
          user
        } = yield fetchUser(_this);
        commit(SET_USER, user);
      } catch (err) {
        console.log(err);
      }
    })();
  }

};